export enum ExamType {
  MARITIME = 'MARITIME',
  FLUVIAL = 'FLUVIAL',
}
